<div class="col w-100">
	<div class="form-group" [formGroup]="Form">
		<label *ngIf="labelVisible">{{labelName}}</label>
		<textarea ktSelectOnClick #controlInput class="form-control w-100"
			   formControlName="Text" tabindex="{{tabindex}}"
			   rows={{rows}} cols="{{cols}}"></textarea>
		<kt-inline-server-validation [ngClass]="{'d-none': !showValidation}" [input]="controlInput" [formGroup]="Form" [field]="'Text'"></kt-inline-server-validation>
	</div>
</div>
